/**
 * OVERRIDE DefaultBody.jsx
 * REASON: Look up Summary component.
 */

import DefaultBody from '../../../../../../components/Blocks/Teaser/DefaultBody';

export default DefaultBody;
